import ThemeToggle from './ThemeToggle';
import SidebarNav from './SidebarNav';
import { useNav } from '../hooks/useDocs';
import { useSettings } from '../hooks/useSettings';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { Dialog } from '@headlessui/react';
import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';

const AppShell = () => {
  const { data: nav } = useNav();
  const { settings } = useSettings();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-8 lg:grid-cols-[280px_1fr]">
        <div className="hidden h-[calc(100vh-4rem)] overflow-y-auto overflow-x-hidden rounded-3xl border border-slate-200 bg-white/80 p-6 shadow-card backdrop-blur dark:border-slate-800 dark:bg-slate-900/60 lg:block lg:sticky lg:top-8">
          <SidebarNav nav={nav} />
        </div>
        <div className="lg:hidden">
          <button
            type="button"
            className="flex w-full items-center justify-between rounded-2xl border border-slate-200 bg-white/80 px-4 py-3 shadow-card dark:border-slate-800 dark:bg-slate-900/60"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="font-semibold text-slate-800 dark:text-slate-100">Browse documentation</span>
            <Bars3Icon className="h-6 w-6 text-slate-600" />
          </button>
        </div>
        <main className="space-y-8">
          <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-4">
              {settings?.platformLogo && (
                <Link to="/" className="flex-shrink-0">
                  <img
                    src={settings.platformLogo}
                    alt={settings.platformName || 'Logo'}
                    className="h-10 w-auto object-contain"
                  />
                </Link>
              )}
              <div>
                <Link to="/" className="block">
                  <p className="text-sm font-semibold uppercase tracking-wider text-brand-500">
                    {settings?.platformName || 'Workloob'} Documentation
                  </p>
                </Link>
                <h1 className="text-3xl font-bold text-slate-900 dark:text-white">
                  {settings?.platformTagline || 'Build with confidence'}
                </h1>
                <p className="text-sm text-slate-500 dark:text-slate-400">
                  Everything you need know about {settings?.platformName || 'Workloob'}.
                </p>
              </div>
            </div>
            <ThemeToggle />
          </header>
          <Outlet />
        </main>
      </div>

      <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
        <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
        <Dialog.Panel className="fixed inset-y-0 left-0 w-72 bg-white p-6 dark:bg-slate-900">
          <SidebarNav nav={nav} onNavigate={() => setSidebarOpen(false)} />
        </Dialog.Panel>
      </Dialog>
    </div>
  );
};

export default AppShell;

